/* globals $:false */

import ui from '@cob/ui-genesis/cob.ui.js';

var BulkRequestM = function(core) {
    this._core = core;
};

BulkRequestM.prototype._pushRequest = function(request) {
    $.ajax({
        url: "recordm/instances/bulk",
        type: "post",
        contentType: "application/json",
        data: JSON.stringify(request),
        success: function() {
            ui.notification.showInfo(
                this._core.translateString("recordm.search", "bulkrequest.in-progress")
            );
        }.bind(this)
    });
};

BulkRequestM.prototype.updateInstances = function(definitionId, query, ids, instanceData) {
    this._pushRequest({
        action: "update",
        definitionId: definitionId,
        query: query,
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
        ids: ids,
        body: instanceData
    })
};

BulkRequestM.prototype.deleteInstances = function(definitionId, query, ids) {
    this._pushRequest({
        action: "delete",
        definitionId: definitionId,
        query: query,
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
        ids: ids
    })
};

export default BulkRequestM;
